import { render, staticRenderFns } from "./GaleryRoomAdd.vue?vue&type=template&id=77804f2a"
import script from "./GaleryRoomAdd.vue?vue&type=script&lang=js"
export * from "./GaleryRoomAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports